<div class="tag-list-wrapper">
  <div class="tag-list-title" *ngIf="showTitle">{{ title | translate }}</div>

  <div
    class="tag-list-content"
    [style.maxHeight.px]="maxListHeight"
    [class.tag-list-content--scrollable]="tags.length > maxVisible"
  >
    <app-driveb-tag-chip
      *ngFor="let tag of tags"
      [tag]="tag"
      [removable]="removable"
      (remove)="onRemoveTag($event)"
    ></app-driveb-tag-chip>

    <span class="tag-list-empty" *ngIf="!tags.length">
      {{ 'service-request.tag.empty' | translate }}
    </span>
  </div>
</div>
